import type {
  AutomationCase,
  AutomationDraft,
  AutomationRef,
  AutomationSavedView,
  AutomationSummary,
  AutomationTask,
} from "@rutamagica/contracts";
import { apiRequest, useDevelopmentFixtures } from "../api/client";
export type TaskPage = {
  data: AutomationTask[];
  meta: { page: number; perPage: number; total: number };
};
export type CasePage = {
  data: AutomationCase[];
  meta: { page: number; perPage: number; total: number };
};
const root = "/api/v1/crm/automation";
const path = (ref: AutomationRef) =>
  `/cases/${ref.kind}/${encodeURIComponent(ref.id)}`;
const read = async <T>(url: string) =>
  (await apiRequest<{ data: T }>(root + url)).data;
const write = async <T>(url: string, method: string, body: unknown) => {
  if (useDevelopmentFixtures)
    throw new Error(
      "Esta acción requiere el panel conectado. La demostración no realiza envíos.",
    );
  return (
    await apiRequest<{ data: T }>(root + url, {
      method,
      body: JSON.stringify(body),
    })
  ).data;
};
export const automationApi = {
  summary: async () =>
    useDevelopmentFixtures
      ? (await import("../dev/automation-fixtures")).fixtureAutomationSummary()
      : read<AutomationSummary>("/summary"),
  cases: async (query: URLSearchParams) =>
    useDevelopmentFixtures
      ? (await import("../dev/automation-fixtures")).fixtureAutomationCases(
          query,
        )
      : apiRequest<CasePage>(root + "/cases?" + query),
  tasks: async (query: URLSearchParams) =>
    useDevelopmentFixtures
      ? (await import("../dev/automation-fixtures")).fixtureAutomationTasks(
          query,
        )
      : apiRequest<TaskPage>(root + "/tasks?" + query),
  detail: async (ref: AutomationRef) =>
    useDevelopmentFixtures
      ? (await import("../dev/automation-fixtures")).fixtureAutomationCase(ref)
      : read<AutomationCase>(path(ref)),
  refresh: (ref?: AutomationRef) =>
    write((ref ? path(ref) : "") + "/refresh", "POST", {
      commandId: crypto.randomUUID(),
    }),
  treatment: (ref: AutomationRef, input: unknown) =>
    write(path(ref) + "/treatment", "PATCH", input),
  task: (id: string, input: unknown) => write("/tasks/" + id, "PATCH", input),
  views: (service: string) =>
    useDevelopmentFixtures
      ? Promise.resolve([])
      : read<AutomationSavedView[]>(
          "/views?" + new URLSearchParams({ section: "pipeline", service }),
        ),
  saveView: (id: string, input: unknown) =>
    write<AutomationSavedView>("/views/" + id, "PUT", input),
};
